import { render } from "./actionButton.vue?vue&type=template&id=6dff5aac"
import script from "./actionButton.vue?vue&type=script&lang=js"
export * from "./actionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__